import { render, staticRenderFns } from "./CCredit.vue?vue&type=template&id=62b98db2&"
import script from "./CCredit.vue?vue&type=script&lang=js&"
export * from "./CCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports